import React, { useState, useRef, useEffect } from 'react';
import styles from './search-bar.module.css';
import Button from '../ui/button';
import { useRouter } from 'next/router';
import Link from 'next/link';

interface SearchBarProps {
  search_page: string;
  search_placeholder?: string;
  isVisible?: boolean; // Optional prop to control visibility from parent component
  toggleVisibility?: () => void; // Optional prop to handle visibility toggle from parent component
}

export default function SearchBar({
  search_page,
  search_placeholder = 'Search by technology, metals, industries, or any keyword',
  isVisible = false,
  toggleVisibility,
}: SearchBarProps) {
  const { locale, defaultLocale } = useRouter();
  const [internalVisible, setInternalVisible] = useState(isVisible);
  const [searchValue, setSearchValue] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null); // Create a ref for the input element
  const inputMobileRef = useRef<HTMLInputElement>(null); // Create a ref for the input element
  // Check if the screen size is mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Set breakpoint for mobile
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setInternalVisible(isVisible);
  }, [isVisible]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const getSearchUrl = () => {
    return `${locale != defaultLocale ? `/${locale}` : ''}${search_page}?s=${encodeURIComponent(searchValue)}`;
  };

  const handleToggleVisibility = () => {
    if (toggleVisibility) {
      toggleVisibility(); // Use external toggle if provided
    } else {
      setInternalVisible(!internalVisible); // Otherwise, use internal state
    }

    // Use the appropriate ref based on isMobile
    setTimeout(() => {
      const refToUse = isMobile ? inputMobileRef : inputRef;
      if (refToUse.current) {
        refToUse.current.focus();
      }
    }, 0);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      window.location.href = getSearchUrl();
    }
  };

  const visible = toggleVisibility ? isVisible : internalVisible; // Determine which state to use

  return (
    <div className={styles.searchWrapper}>
      {/* <img
        className={styles.searchIcon}
        loading="lazy"
        alt="Search"
        // Change the icon based on visibility and mobile state
        src={isMobile && visible ? '/closex.svg' : '/magnifying.svg'}
        onClick={handleToggleVisibility}
      /> */}
      {/* Desktop search bar */}
      <div className={`${styles.searchBar} ${!isMobile && visible ? styles.searchBarVisible : ''}`}>
        {/* <div className={styles.container}> */}
          {/* <div className={styles.actions}>
            <span className={styles.search}>Search</span>
            <div className={styles.close} onClick={handleToggleVisibility}>
              <span className={styles.close1}>Close</span>
              <img className={styles.closeIcon} loading="lazy" alt="Close" src="/closex.svg" />
            </div>
          </div> */}
          <div className={styles.searchInputBar}>
            <input
              ref={inputRef}
              className={styles.searchInput}
              value={searchValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            <span
              className={styles.searchInputPlaceholder}
              dangerouslySetInnerHTML={{ __html: search_placeholder ? search_placeholder : '<strong>Search for</strong> Multi-Slide Die Cast Tooling, Shrinkage porosity solutions, etc...' }}
            />
            <div className={styles.searchButton}>
              <Link
                href={getSearchUrl()}
                aria-label="Search"
              ></Link>
              {/* <Button
                text="Search"
                link={getSearchUrl()}
                propHeight="28px"
                propWidth="98px"
                propBackgroundColor="var(--primary-500)"
                propBorderColor="var(--primary-500)"
                propTextColor="white"
                propHoverText="white"
              /> */}
            </div>
          </div>
        {/* </div> */}
      </div>

      {/* Mobile overlay */}
      <div
        className={`${styles.mobileOverlay} ${isMobile && visible ? styles.searchOverlayVisible : ''}`}
        style={{
          transition: 'max-height 0.5s ease',
          maxHeight: visible ? '100%' : '0px',
          overflow: 'hidden',
        }}
      >
        <div className={styles.mobileContainer}>
          <span className={styles.searchTitleMobile}>Search</span>
          <div className={styles.searchInputBarMobile}>
            <input
              ref={inputMobileRef}
              className={styles.searchInputMobile}
              placeholder={search_placeholder}
              value={searchValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            <div className={styles.searchButtonMobile}>
              <Button
                text="Search"
                link={getSearchUrl()}
                propHeight="2.625rem"
                propWidth="7.5625rem"
                propBackgroundColor="var(--primary-500)"
                propBorderColor="var(--primary-500)"
                propTextColor="white"
                propHoverText="white"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
